import classNames from 'classnames'
import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { PointCardType } from 'types/pointCard'
import { getExpiration } from 'lib/pointCard'

type Props = {
  pointCard: Pick<PointCardType, 'color' | 'expiration' | 'grades' | 'icon_url' | 'name'>
}

const PointCardPreviewCard: FC<Props> = (props) => {
  const { pointCard } = props
  const expiration = getExpiration(pointCard.expiration, 'card')
  // pointCard.colorが黄色かクリーム色なら黒色
  const textColor = pointCard.color === '#F8E220' || pointCard.color === '#EEEEE3' ? text.color_black : text.color_white
  const iconBorderColor =
    pointCard.color === '#F8E220' || pointCard.color === '#EEEEE3' ? { borderColor: 'black' } : { borderColor: 'white' }
  return (
    <div className={classNames(styles.pointCardPreview__container)}>
      <div className={classNames(styles.pointCardPreview__inner)} style={{ backgroundColor: pointCard.color }}>
        <div className={classNames(styles.pointCardPreview__grade)}>{pointCard.grades[0]?.name}</div>
        <div className={classNames(styles.pointCardPreview__body)}>
          <img
            className={classNames(styles.pointCardPreview__icon)}
            alt={'ポイントカードアイコン'}
            src={pointCard.icon_url}
            style={iconBorderColor}
          />
          <div>
            <h2 className={classNames(text.font_medium, text.font_bold, textColor)}>{pointCard.name}</h2>
            <Spacer size={8} />
            <p className={classNames(text.font_small, textColor)}>有効期限 : {expiration}</p>
          </div>
        </div>
        <p className={classNames(styles.pointCardPreview__points)}>
          <span className={classNames(styles.pointCardPreview__point, textColor)}>9,999</span>
          <span className={classNames(text.font_xlarge, text.font_bold, textColor)}>pt</span>
        </p>
        <img className={classNames(styles.pointCardPreview__background)} src={'/logo/watermark.svg'} />
      </div>
    </div>
  )
}

export default PointCardPreviewCard
